<template>
  <template v-if="$route.name === 'settings.areas.index'">
    <AreasFilter
      v-model="search"
      @search="onSearch"
      @add="gotoAdd"
    />

    <AreasTable
      :items="items"
      :loading="loading"
      @edit="gotoEdit"
      @delete="confirmDelete"
    >
      <template #pagination>
        <PaginationControls
          v-if="!loading && pagination.total > 0"
          :pagination="{
            currentPage: pagination.currentPage,
            perPage: pagination.perPage,
            totalItems: pagination.total,
            totalPages: pagination.lastPage,
            from: pagination.from,
            to: pagination.to
          }"
          @page-changed="fetchList"
        />
      </template>
    </AreasTable>

    <BaseDialog
      ref="del"
      :title="t('common.delete')"
      confirm-variant="danger"
      :confirm-text="t('common.delete')"
      :loading="delLoading"
      @confirm="doDelete"
    >
      <template #body>
        <p>{{ t('settings.areas.deleteConfirm') }} <strong>{{ selected?.name }}</strong></p>
      </template>
    </BaseDialog>
  </template>

  <router-view />
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import AreasFilter from '@/components/features/areas/AreasFilter.vue'
import AreasTable from '@/components/features/areas/AreasTable.vue'
import PaginationControls from '@/components/common/PaginationControls.vue'
import BaseDialog from '@/components/common/BaseDialog.vue'
import { useToast } from 'vue-toastification'

const { t } = useI18n()
const toast = useToast()
const router = useRouter()
const store = useStore()

const del = ref(null)
const delLoading = ref(false)
const selected = ref(null)

const loading = computed(() => store.getters['areas/isLoading'])
const items = computed(() => store.getters['areas/items'])
const pagination = computed(() => store.getters['areas/pagination'])
const search = ref(store.getters['areas/search'] || '')

const fetchList = async (page = pagination.value.currentPage) => {
  await store.dispatch('areas/fetch', page)
}
const onSearch = () => {
  store.commit('areas/SET_SEARCH', search.value)
  fetchList(1)
}
const gotoAdd = () => router.push({ name: 'settings.areas.create' })
const gotoEdit = (id) => router.push({ name: 'settings.areas.edit', params: { id } })
const confirmDelete = (row) => { selected.value = row; del.value?.openDialog() }

const doDelete = async () => {
  if (!selected.value) return
  delLoading.value = true
  try {
    await store.dispatch('areas/delete', selected.value.id)
    toast.success(t('common.deleted'))
    del.value?.closeDialog()
    selected.value = null

    const isLastOnPage = items.value.length === 1 && pagination.value.currentPage > 1
    await fetchList(isLastOnPage ? pagination.value.currentPage - 1 : pagination.value.currentPage)
  } catch (e) {
    toast.error(e?.response?.data?.message || t('common.deleteFailed'))
  } finally {
    delLoading.value = false
  }
}

fetchList()
</script>
